import React, { Component } from 'react';
import { nanoid } from 'nanoid';
import StagesManager from '../components/StagesManager';
import TemplatesView from './TemplatesView';
import TemplatesPreview from './TemplatesPreview';

class Templates extends Component {

    state = {
        data: [
            { id: nanoid(), title: 'Manufacturing Inspection System [AI]', img: '/assets/icons/templates/template1.jpeg' },
            { id: nanoid(), title: 'Products Info in Live Commerce [AI]', img: '/assets/icons/templates/template2.jpeg' },
            { id: nanoid(), title: 'Agile project management', img: '/assets/icons/templates/template3.jpeg' },
            { id: nanoid(), title: 'Sequence Diagram', img: '/assets/icons/templates/template4.jpeg' }
        ]
    }

    changePreview = (index, previewData) => {
        this.setState({ previewNum: index, previewData }, () => {
            this.stageManager.changeStage('tempalesPreview')
        })
    }

    changePage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    render() {
        return (
            <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                <TemplatesView stage={0} stageName='tempalesView' data={this.state.data} previewNum={this.state.previewNum} width={this.props.width} onClick={this.props.onClick} background={this.props.background} changePage={this.changePage} changePreview={this.changePreview} />
                <TemplatesPreview stage={1} stageName='tempalesPreview' data={this.state.data} width={this.props.width} previewNum={this.state.previewNum} previewData={this.state.previewData} onClick={this.props.onClick} background={this.props.background} changePage={this.changePage} changePreview={this.changePreview} />
            </StagesManager>
        );
    }
}

export default Templates;